import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Typography from '../../atoms/typography';

const StyledContainer = styled.header`
  align-items: center;
  color: ${(props) => props.theme.color.brand};
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.font.serif};
  line-height: 2.2rem;
  text-align: center;
  line-height: 2.2rem;
`;

const PriceWrapper = styled(Typography)`
  color: ${(props) => props.theme.color.brand};
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  line-height: 2.2rem;
  order: 3;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    flex-direction: row;
  }
`;

const BrandWrapper = styled(Typography)`
  font-style: italic;
  order: 1;
`;

const NameWrapper = styled(Typography)`
  order: 2;
`;

const PriceOriginal = styled.div``;

const PriceSale = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${PriceOriginal} {
    color: ${(props) => props.theme.color.brand};
    margin-right: 0.5rem;
    position: relative;

    ::before {
      content: '';
      width: 100%;
      height: 1px;
      background: ${(props) => props.theme.color.brand};
      opacity: .5;
      position: absolute;
      left: 0;
      top: 50%;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    &::after {
      content: '|';
      margin:  0 0.5rem;
      display: inline-block;
    }
  }
`;

const PricePercentage = styled.div`
  color: ${(props) => props.theme.color.brandA11yRed};
`;

const priceData = (product) => {
  if (product.onsale && product.percent_off) {
    if (product.niceprice_lower && product.niceprice_upper) {
      return (
        <>
          <PriceSale>{`${product.niceprice_lower} - ${product.niceprice_upper}`}</PriceSale>
          <PricePercentage>{`UP TO ${product.percent_off}`}</PricePercentage>
        </>
      );
    }

    return (
      <>
        <PriceSale>
          <PriceOriginal>{product.origprice}</PriceOriginal>
          {`${product.niceprice}`}
        </PriceSale>
        <PricePercentage>{`${product.percent_off}`}</PricePercentage>
      </>
    );
  }

  if (product.niceprice_lower && product.niceprice_upper) {
    return <PriceOriginal>{`${product.niceprice_lower} - ${product.niceprice_upper}`}</PriceOriginal>;
  }

  return <PriceOriginal>{product.niceprice}</PriceOriginal>;
};

const ProductTitle = (props) => (
  <StyledContainer product={props.product}>
    <NameWrapper element="h2" like="paragraph-2">{props.product.title}</NameWrapper>
    <BrandWrapper element="h3" like="paragraph-2">{props.product.brand}</BrandWrapper>
    <PriceWrapper element="div" like="label-1">{priceData(props.product)}</PriceWrapper>
  </StyledContainer>
);

ProductTitle.propTypes = {
  product: PropTypes.object.isRequired
};

ProductTitle.whyDidYouRender = true;

export default ProductTitle;
export {
  priceData,
  PriceWrapper
};
